<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="房源" name="0"></el-tab-pane>
            <el-tab-pane label="路线" name="6"></el-tab-pane>
            <el-tab-pane label="景点" name="1"></el-tab-pane>
            <el-tab-pane label="温泉" name="2"></el-tab-pane>
            <el-tab-pane label="美食" name="3"></el-tab-pane>
        </el-tabs>
        <div class="card-content" v-loading="loading">
            <component :is="comName" v-for="(item,index) in list" :type="currentType" :key="index" :item="item.info"></component>
            <el-alert v-if="list.length<=0" title="暂无收藏~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    import HouseCard from "../../components/HouseCard";
    import LineCard from "../../components/LineCard";
    import StoryCard from "../../components/StoryCard";
    export default {
        name: "collection",
        components: {HouseCard, LineCard, StoryCard},
        data() {
            return {
                activeName: '0',
                list: [],
                loading: false
            }
        },
        created() {
            this.getCollection();
        },
        computed:{
            comName(){
                switch (this.activeName) {
                    case "0":
                        return 'HouseCard'
                    case "1":
                        return 'StoryCard'
                    case "2":
                        return 'StoryCard'
                    case "3":
                        return 'StoryCard'
                    case "6":
                        return 'LineCard'
                }
            },
            currentType(){
                switch (this.activeName) {
                    case "1":
                        return 2
                    case "2":
                        return 1
                    case "3":
                        return 3
                    default:
                        return 0
                }
            }
        },
        methods: {
            handleClick(tab) {
                this.getCollection();
            },
            async getCollection(){
                this.loading = true;
                let [e, data] = await this.$api.getCollectionApi({mark: +this.activeName})
                this.loading = false;
                if(data.code === 200){
                    this.list = data.result.filter(it=>it.info);
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .card-content{
        width: 100%;
    }
</style>
